<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">让我们认识一下常见的页面</div>
      </div>
    </div>
    <div class="module_box">
      <div class="module" @click.stop.prevent="goDropDown">
        <div class="module_img dropDown"></div>
        <div class="module_text">下拉页面</div>
      </div>
      <div class="module" @click.stop.prevent="goPopup">
        <div class="module_img popup"></div>
        <div class="module_text">弹窗页面</div>
      </div>
      <div class="module" @click.stop.prevent="goChatMessage">
        <div class="module_img chatMessage"></div>
        <div class="module_text">聊天信息页面</div>
      </div>
      <div class="module" @click.stop.prevent="goSocialCircle">
        <div class="module_img socialCircle"></div>
        <div class="module_text">社交圈页面</div>
      </div>
      <div class="module" @click.stop.prevent="goChatWindow">
        <div class="module_img chatWindow"></div>
        <div class="module_text">聊天窗口页面</div>
      </div>
      <div class="module" @click.stop.prevent="goHomePage">
        <div class="module_img homePage"></div>
        <div class="module_text">首页</div>
      </div>
      <div class="module" @click.stop.prevent="goLogin">
        <div class="module_img login"></div>
        <div class="module_text">登录页面</div>
      </div>
      <div class="module" @click.stop.prevent="goContentList">
        <div class="module_img contentList"></div>
        <div class="module_text">内容列表页面</div>
      </div>
      <div class="module" @click.stop.prevent="goContentDetails">
        <div class="module_img contentDetails"></div>
        <div class="module_text">内容详情页面</div>
      </div>
      <div class="module" @click.stop.prevent="goPersonalCenter">
        <div class="module_img personalCenter"></div>
        <div class="module_text">个人中心页面</div>
      </div>
      <div class="module" @click.stop.prevent="goShoppingCart">
        <div class="module_img shoppingCart"></div>
        <div class="module_text">购物车页面</div>
      </div>
      <div class="module" @click.stop.prevent="goOrderConfirmation">
        <div class="module_img orderConfirmation"></div>
        <div class="module_text">订单确认页面</div>
      </div>
      <div class="module" @click.stop.prevent="goOrderDetails">
        <div class="module_img orderDetails"></div>
        <div class="module_text">订单详情页面</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pageIndex',
  components: {},
  data () {
    return {}
  },
  created () {},

  mounted () {},
  beforeDestroy () {},

  methods: {
    async goBack () {
      this.$router.replace({
        path: '/recognize/recognizeIndex'
      })
    },
    async goDropDown () {
      this.$router.push({
        path: '/recognize/page/dropDown/index1'
      })
    },
    async goPopup () {
      this.$router.push({
        path: '/recognize/page/popup/index1'
      })
    },
    async goChatMessage () {
      this.$router.push({
        path: '/recognize/page/chatMessage/index1'
      })
    },
    async goSocialCircle () {
      this.$router.push({
        path: '/recognize/page/socialCircle/index1'
      })
    },
    async goChatWindow () {
      this.$router.push({
        path: '/recognize/page/chatWindow/index1'
      })
    },
    async goHomePage () {
      this.$router.push({
        path: '/recognize/page/homePage/index1'
      })
    },
    async goLogin () {
      this.$router.push({
        path: '/recognize/page/login/index1'
      })
    },
    async goContentList () {
      this.$router.push({
        path: '/recognize/page/contentList/index1'
      })
    },
    async goContentDetails () {
      this.$router.push({
        path: '/recognize/page/contentDetails/index1'
      })
    },
    async goPersonalCenter () {
      this.$router.push({
        path: '/recognize/page/personalCenter/index1'
      })
    },
    async goShoppingCart () {
      this.$router.push({
        path: '/recognize/page/shoppingCart/index1'
      })
    },
    async goOrderConfirmation () {
      this.$router.push({
        path: '/recognize/page/orderConfirmation/index1'
      })
    },
    async goOrderDetails () {
      this.$router.push({
        path: '/recognize/page/orderDetails/index1'
      })
    }
  }
}
</script>

<style scoped lang="less">
.Index {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgb(95, 141, 255) 6.107%,
    rgb(144, 181, 252) 39.695%,
    rgb(217, 240, 255) 99.237%
  );
  border-radius: 0px;
  .window_bg {
    pointer-events: none; /* 使点击穿透该元素 */
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/use/useIndex/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  //   display: flex;
  //   align-items: flex-end;
  //   justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/use/useIndex/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 40px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      text-align: center;
      margin-top: 41px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 45px;
      //   width: 420px;
      color: #ffffff;
      // line-height: 82px;
    }
  }
}

.module_box {
  // width: 100%;
  max-height: 73vh;
  display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  overflow-y: auto;
  padding: 0 22px;
  // display: grid;
  // justify-content: space-between;
  // justify-items: center;
  // grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  // grid-gap: 10px 1px;

  .module {
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    // width: 42.5%;
    padding: 10px 20px;
    margin-bottom: 25px;
    border-radius: 20px;
    background: rgb(255, 255, 255);
    .module_img {
      width: 298px;
      height: 342px;
    }
    .module_text {
      margin-top: 10px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 32px;
      color: rgb(51, 51, 51);
      line-height: 39px;
    }
    .dropDown {
      background: url("@/assets/recognize/page/pageIndex/dropDown.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .popup {
      background: url("@/assets/recognize/page/pageIndex/popup.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .chatMessage {
      background: url("@/assets/recognize/page/pageIndex/chatMessage.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .socialCircle {
      background: url("@/assets/recognize/page/pageIndex/socialCircle.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .chatWindow {
      background: url("@/assets/recognize/page/pageIndex/chatWindow.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .homePage {
      background: url("@/assets/recognize/page/pageIndex/homePage.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .login {
      background: url("@/assets/recognize/page/pageIndex/login.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .contentList {
      background: url("@/assets/recognize/page/pageIndex/contentList.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .contentDetails {
      background: url("@/assets/recognize/page/pageIndex/contentDetails.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .personalCenter {
      background: url("@/assets/recognize/page/pageIndex/personalCenter.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .shoppingCart {
      background: url("@/assets/recognize/page/pageIndex/shoppingCart.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .orderConfirmation {
      background: url("@/assets/recognize/page/pageIndex/orderConfirmation.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .orderDetails {
      background: url("@/assets/recognize/page/pageIndex/orderDetails.png")
        no-repeat center;
      background-size: 100% 100%;
    }

  }
}
</style>
